// extracted by mini-css-extract-plugin
export default {"title":"questionsTable_title__8FFIr","table":"questionsTable_table__1Cb9Q","actions":"questionsTable_actions__k+Jim","circular-status":"questionsTable_circular-status__-M7f3"};